import { useEffect } from "react";
import { eventPaymentSuccess } from "../utilities/dataLayer";
import { PayPalAndApplePayPurchase } from "../utilities/facebookPixel";
import { POST_LABEL } from "../utilities/constants";

const useHandlePaypalUpdate = (isClientSide) => {
  // When the user completes the payment these field values should be posted.
  useEffect(
    function onLoad() {
      if (!isClientSide) return;
      const query = new URLSearchParams(window.location.search);
      const transaction = query.get("transaction");
      const token = query.get("token");
      const PayerID = query.get("PayerID");

      if (query !== null && token !== null && PayerID !== null) {
        // console.log("everywhere");
        fetch(`${process.env.GATSBY_FORM_ENDPOINT}/paypalupdate`, {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            [POST_LABEL.TRANSACTION]: transaction,
            [POST_LABEL.TOKEN]: token,
            [POST_LABEL.PAYER_ID]: PayerID,
          }),
        })
          .then((res) => res.json())
          .then((res) => {
            // if(
            //   typeof res.ResponseCode !== 'undefined' &&
            //   typeof res.TransactionId !== 'undefined' &&
            //   res.ResponseCode === 0 &&
            //   res.TransactionId !== null
            // ){
            eventPaymentSuccess(res?.TransactionId);
            PayPalAndApplePayPurchase(res?.TransactionId);
            // }
            console.log(res, "res");
            // console.log(res.ResponseCode === 0, "res");
          })
          .catch(function (error) {
            console.log("There has been a problem with your fetch operation: " + error.message);
          });
      }
    },
    [isClientSide]
  );
};

export default useHandlePaypalUpdate;
